// AutoGenerated
import { DizilimHesapModel } from "../businessModels/DizilimHesapModel"

export class DizilimModel {
    konserId!: string;
    sarkiId!: string | null;
    aciklama!: string | null;
    dizilimHesapModelList!: DizilimHesapModel[];
    koroModelId!: string;
    id!: string;
    olusturan!: string;
    olusturmaTarih!: Date;
    guncelleyen!: string | null;
    guncellemeTarih!: Date | null;
}